import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import { ApolloError } from '@apollo/client';
import { GraphQLResponsePaginationInfo, GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { GraphQLSnippet } from '../types';

export interface SnippetQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  paginationInfo: GraphQLResponsePaginationInfo;
  refetch: () => void;
  snippets: GraphQLSnippet[];
  setSelectedSnippet: Dispatch<SetStateAction<any>>;
  selectedSnippet: GraphQLSnippet | null;
}

export const defaultPaginationInfo = {
  count: 0,
  limit: 20,
  offset: 0,
  page: 1,
  __typename: GRAPHQL_TYPENAMES.INFO,
};

export const SnippetQueryContext = createContext<SnippetQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: false,
  paginationInfo: defaultPaginationInfo,
  refetch: () => undefined,
  snippets: [],
  setSelectedSnippet: () => undefined,
  selectedSnippet: null,
});

export const useSnippetQueryContext = () => useContext(SnippetQueryContext);
